<template>
    <main class="contact">
        <div class="page-header">
            <h1 class="page-header__title">Błędy i sugestie</h1>
        </div>
        <form class="contact__wrapper" @submit="handleSubmit">
            <h1 class="contact__title">Zgłoś błąd lub zaproponuj zmianę</h1>
            <div class="form__error" v-if="error">{{ error }}</div>
            <div class="form__success" v-if="success">{{ success }}</div>
            <div class="form__row" v-if="!isAuthenticated">
                <div class="form__col">
                    <input
                        type="text"
                        v-model="form.firstName"
                        placeholder="Imię*"
                        :required="!isAuthenticated"
                    />
                </div>
                <div class="form__col">
                    <input
                        type="text"
                        v-model="form.email"
                        placeholder="Adres e-mail*"
                        :required="!isAuthenticated"
                    />
                </div>
            </div>
            <div class="contact__center">
        <textarea
            class="contact__field"
            v-model="form.message"
            placeholder="Wpisz tutaj wiadomość..."
            rows="4"
        ></textarea>
                <button class="btn btn__contact">Wyślij</button>
            </div>
            <div class="contact__row contact-actions">
                <div class="contact-actions__item">
                    <div class="contact-actions__link">
                        <img src="@/assets/svg/envelope.svg" class="contact__icon" alt="E-mail"/>kontakt@racer-online.pl
                    </div>
                </div>
                <div class="contact-actions__item">
                    <div class="contact-actions__link">
                        <img src="@/assets/svg/phone.svg" class="contact__icon" alt="Phone"/>+48 884 700 069
                    </div>
                </div>
            </div>
        </form>
    </main>
</template>

<script>
import { mapGetters } from "vuex";
import platform from "platform";
import axios from "axios";

export default {
    name: "Comments",
    data() {
        return {
            error: "",
            success: "",
            form: {
                message: "",
                firstName: "",
                email: ""
            }
        };
    },
    computed: mapGetters({
        isAuthenticated: "isAuthenticated",
        token: "getToken"
    }),
    methods: {
        getExtendedMessage() {
            return `${this.form.message}\n\n${platform.description}`;
        },
        handleSubmit(e) {
            e.preventDefault();

            this.error = "";

            if (!this.isAuthenticated && (!this.form.firstName || !this.form.email)) {
                this.error = "Musisz podać imię oraz adres e-mail";
            }

            if (!this.form.message) {
                this.error = "Musisz wpisać wiadomość";
                return;
            }

            if (this.isAuthenticated) {
                axios({
                    method: "post",
                    url: `${process.env.VUE_APP_API_URL}/contact`,
                    headers: {
                        "Content-type": "application/json",
                        Authorization: `Bearer ${this.token}`
                    },
                    data: {
                        message: this.getExtendedMessage()
                    }
                }).then(() => {
                    this.success = "Wiadomość została wysłana";
                    this.$store.dispatch('refreshUserToken')
                }).catch(error => {
                    this.error = `Wystąpił błąd: ${error}`
                });
            } else {
                axios({
                    method: "post",
                    url: `${process.env.VUE_APP_API_URL}/public/contact`,
                    headers: {
                        "Content-type": "application/json"
                    },
                    data: {
                        message: this.getExtendedMessage(),
                        firstName: this.form.firstName,
                        email: this.form.email
                    }
                }).then(() => {
                    this.success = "Wiadomość została wysłana";
                }).catch(error => {
                    this.error = `Wystąpił błąd: ${error}`
                });
            }
        }
    }
};
</script>

